<div *ngIf='field || (errors !== null)' class='invalid-value'>
  <div *ngIf='field.length === 0'>{{label}} {{ 'GENERAL.REQUIRED' | translate }}</div>
  <div *ngIf="errors && errors['min']">{{ 'GENERAL.MINIMUM' | translate }} {{errors['min'].min}}</div>
  <div *ngIf="errors && errors['max']">{{ 'GENERAL.MAXIMUM' | translate }} {{errors['max'].max}}</div>
</div>
